import { FieldConfig, FieldHookConfig, useField } from 'formik';
import { ElementType, ForwardRefRenderFunction, forwardRef } from 'react';

interface Props extends Omit<FieldConfig, 'as'> {
  as?: ElementType;
  namePrefix?: string;
  setValueProp?: string;
  setTouchedProp?: string;
  setErrorProp?: string;
  // Field forwards any additional props through to the underlying `as`
  // component, so allow arbitrary passthrough props.
  [key: string]: unknown;
}

const Field: ForwardRefRenderFunction<unknown, Props> = (
  {
    setValueProp,
    setTouchedProp,
    setErrorProp,
    namePrefix = '',
    name,
    as: AsComponent = 'input',
    ...rest
  },
  forwardedRef
) => {
  const props = { name: `${namePrefix}${name}`, ...rest };

  const [field, meta, { setValue, setTouched, setError }] = useField(
    props as FieldHookConfig<unknown>
  );

  const componentProps = {
    meta,
    ...field,
    ...props,
    ...(setValueProp ? { [setValueProp]: setValue } : {}),
    ...(setTouchedProp ? { [setTouchedProp]: setTouched } : {}),
    ...(setErrorProp ? { [setErrorProp]: setError } : {}),
  };

  return <AsComponent ref={forwardedRef} {...componentProps} />;
};

export default forwardRef(
  Field as ForwardRefRenderFunction<unknown, Omit<Props, 'ref'>>
);
